import { trackingPrint } from '@app/model';
import { AppShell, TabbarContainer } from '@app/ui';
import { autoWebViewJs } from '@droid/android';
import { Dispatcher, IDispatcher, nextPreload } from '@fanfanlo';
import { Box, Button, Grid2, Link, IconButton } from '@mui/material';
import { InviteEmergencyContactButton } from '@src/components/pages/home/components/InviteEmergencyContactButton';
import { ContactsManagementButton } from '@src/components/pages/home/components/ContactsManagementButton';
import { DesktopShortcutButton } from '@src/components/pages/home/components/DesktopShortcutButton';
import { ProductIntroductionButton } from '@src/components/pages/home/components/ProductIntroductionButton';
import { UserGuideButton } from '@src/components/pages/home/components/UserGuideButton';
import { InviteContactDialog } from '@src/components/dialogs/InviteContactDialog';
import EmergencyStopButton from '@src/components/emergency-audio-control/EmergencyStopButton';
import { EmergencyTTSSettings } from '@src/components/emergency-tts-settings';
import { ErrorDisplay } from '@src/components/error-display/ErrorDisplay';
import MeetingList from '@src/components/meeting-list/MeetingList';
import { NavBar } from '@src/components/navbar/NavBar';
import { EmergencyCallSettings } from '@src/components/pages/home';
import AddWidgetButton from '@src/components/pages/home/components/AddWidgetButton';
import AddSecurityWidgetButton from '@src/components/pages/home/components/AddSecurityWidgetButton';
import PendingInvitationsList from '@src/components/PendingInvitationsList/PendingInvitationsList';
import PreAlarmConfig2 from '@src/components/pre-alarm-config2';
import { ListenShowPrivacyContent } from '@src/components/privacies/ListenShowPrivacyContent';
import SensorMonitor from '@src/components/sensor-monitor/SensorMonitor';
import ShakeConfigUI from '@src/components/shakeconfig/ShakeConfigUI';
import { TestEmergencyCall } from '@src/components/test/TestEmergencyCall';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { HomeFontSizeButton } from "@src/components/home/HomeFontSizeButton";

function Content() {
  const [openInviteDialog, setOpenInviteDialog] = useState(false);

  const router = useRouter();

  React.useEffect(() => {
    nextPreload(router, '/intro');
    nextPreload(router, '/how-to-use');
  }, []);

  return (
    <Box sx={{ my: 2, p: 2 }}>
      <ErrorDisplay />
      {/* 紧急停止按钮 - 置顶显示 */}
      <EmergencyStopButton fullWidth size="large" />

      <Box>
        <Link href="/how-to-use" style={{ textDecoration: 'none' }}>
          如何使用</Link>
      </Box>
      <ListenShowPrivacyContent type="main" />
      {/* <InvitationManager /> */}
      {/* <MeetingList maxItemLength={3} /> */}
      <PendingInvitationsList />

      <Grid2 container spacing={2} sx={{ m: 2 }}>
        <Grid2 size={6}>
          <ProductIntroductionButton />
        </Grid2>
        <Grid2 size={6}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <UserGuideButton />
          </Box>
        </Grid2>
      </Grid2>
      <PreAlarmConfig2 />
      <EmergencyTTSSettings />
      {/* <PreAlarmConfigComponent /> */}

      {/* <JpushIsInitialized /> */}

      <Grid2 container sx={{ mt: 2, mb: 2 }}>
        <Grid2 size={6}>
          <TestEmergencyCall />
        </Grid2>
        <Grid2 size={6}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <EmergencyStopButton variant="button" />
          </Box>
        </Grid2>
      </Grid2>

      {/* 添加桌面小部件按钮 */}
      <AddWidgetButton
        onSuccess={() => {
          console.log('医疗小部件添加成功');
        }}
        onError={(error) => {
          console.error('医疗小部件添加失败:', error);
        }}
      />


      {/* gemini做的权限管理，不好，先不启用 */}
      {/* <SensorPermissions /> */}
      {/* 摇一摇 */}
      <ShakeConfigUI />

      <SensorMonitor />
      {/* 二合一的前台服务 */}
      {/* <UnifiedMonitoringControl /> */}

      {/*  统一监控控制 - 集成传感器监控和权限监控 */}

      <Grid2 container spacing={2} sx={{ m: 2 }}>
        <Grid2 size={6}>
          <Button
            variant="contained"
            onClick={() => {
              // 邀请紧急联系人按钮点击埋点
              trackingPrint({
                params: {
                  type: "用户操作",
                  title: "联系人管理",
                  subtitle: "邀请联系人-按钮点击",
                  extra: {
                    timestamp: Date.now(),
                    page: "home"
                  }
                }
              });
              setOpenInviteDialog(true);
            }}
          >
            邀请紧急联系人
          </Button>
        </Grid2>
        <Grid2 size={6}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                router.push('/contacts');
              }}>
              联系人管理
            </Button>
          </Box>
        </Grid2>
      </Grid2>
      {openInviteDialog && <InviteContactDialog
        open={openInviteDialog}
        onClose={() => {
          // 邀请联系人对话框关闭埋点
          trackingPrint({
            params: {
              type: "模态框操作",
              title: "联系人管理",
              subtitle: "邀请对话框-关闭",
              extra: {
                timestamp: Date.now(),
                page: "home"
              }
            }
          });
          setOpenInviteDialog(false);
        }}
      />}

      {/* <MeetingRoom5
        roomName="test-room"
        userName={`user-${Math.random().toString(36).substring(2, 8)}`}
        livekitConfig={mainModel.appConfig.livekit}
        // role="initiator" // Add role for testing
      />
       */}

      {/* TTS录制与分享 */}
      {/* <TTSRecorder /> */}
      {/* 桌面快捷方式 */}
      {/* <ShortcutConfig /> */}

      <Box sx={{ mt: 2, mb: 2 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={() => {
            router.push('/shortcut');
          }}>
          桌面快捷方式
          {/* <Link href={"/shortcut"}>桌面快捷方式</Link> */}
        </Button>
      </Box>
      {/* <EmergencyAudioControl /> */}
      {/* 浮动紧急停止按钮 */}
      {/* <EmergencyStopButton variant="fab" /> */}

      {/* <Box>
      <Link href={"/logs"}>日志</Link>
      <IMOpenPageLink />
</Box> */}

      <Box sx={{ mt: '2rem' }}></Box>
    </Box>
  );
}


function Content2() {
  const [dispatcher] = useState<IDispatcher>(new Dispatcher())
  const router = useRouter();
  // const [openInviteDialog, setOpenInviteDialog] = useState(false);
  return (
    <Box sx={{ position: 'relative' }}>
      <HomeFontSizeButton />

      <ListenShowPrivacyContent type="main" dispatcher={dispatcher} />
      <ErrorDisplay />
      <PendingInvitationsList />
      <EmergencyCallSettings dispatcher={dispatcher} />

      <TestEmergencyCall />
      <Grid2 container spacing={3} sx={{ mt: 2, px: 2 }}>
        {/* 邀请紧急联系人按钮 */}
        <Grid2 size={6}>
          <InviteEmergencyContactButton />
        </Grid2>
        <Grid2 size={6}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ContactsManagementButton />
          </Box>
        </Grid2>
      </Grid2>

      {/* <AddWidgetButton 
        onSuccess={() => {
          console.log('小部件添加成功');
        }}
        onError={(error) => {
          console.error('小部件添加失败:', error);
        }}
      />
      <AddSecurityWidgetButton 
        onSuccess={() => {
          console.log('安全小部件添加成功');
        }}
        onError={(error) => {
          console.error('安全小部件添加失败:', error);
        }}
      /> */}
      <Box sx={{ mt: 2, mb: 2, px: 2 }}>
        <DesktopShortcutButton />
      </Box>
      <MeetingList maxItemLength={1} />

      <Grid2 container spacing={2} sx={{ m: 2 }}>
        <Grid2 size={6}>
          <ProductIntroductionButton />
        </Grid2>
        <Grid2 size={6}>

          <UserGuideButton />
        </Grid2>
      </Grid2>
    </Box>
  )
}
export default function Home() {
  return (
    <AppShell>
      <TabbarContainer titleConf={{ ns: 'emergency-call/pages/home/content', key: 'home.title' }} navBar={<NavBar />}>
        <Content2 />
      </TabbarContainer>
    </AppShell>
  );
}
